import { render, staticRenderFns } from "./QuestionsAndAnswers.vue?vue&type=template&id=3f4bc326&scoped=true&"
import script from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
export * from "./QuestionsAndAnswers.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsAndAnswers.vue?vue&type=style&index=0&id=3f4bc326&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f4bc326",
  null
  
)

export default component.exports